module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Factory Name",
      "rules": _vm.nameRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.factoryName),
      callback: function($$v) {
        _vm.factoryName = $$v
      },
      expression: "factoryName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Factory Description",
      "rules": _vm.descriptionRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.factoryDescription),
      callback: function($$v) {
        _vm.factoryDescription = $$v
      },
      expression: "factoryDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Address:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Address",
      "rules": _vm.addressRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.factoryAddress),
      callback: function($$v) {
        _vm.factoryAddress = $$v
      },
      expression: "factoryAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddFactory()
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}